export const GET_CURRENCIES = "GET_CURRENCIES";
export const GET_CURRENCY = "GET_CURRENCY";
export const ADD_CURRENCY = "ADD_CURRENCY";
export const DELETE_CURRENCY = "DELETE_CURRENCY";
export const UPDATE_CURRENCY = "UPDATE_CURRENCY";
